import React, { useState } from "react";
import Nav from "./Navigation.js";

const LightsOutSolver = () => {
  const [input, setInput] = useState(Array(9).fill(false));
  const [result, setResult] = useState(Array(9).fill(false));

  const press = (input, pressed) => {
    if (pressed & 1) input = input ^ 0xb;
    if (pressed & 2) input = input ^ 0x17;
    if (pressed & 4) input = input ^ 0x26;
    if (pressed & 8) input = input ^ 0x59;
    if (pressed & 16) input = input ^ 0xba;
    if (pressed & 32) input = input ^ 0x134;
    if (pressed & 64) input = input ^ 0xc8;
    if (pressed & 128) input = input ^ 0x1d0;
    if (pressed & 256) input = input ^ 0x1a0;
    return input;
  };

  const solve = () => {
    let grid = 0;
    for (let i = 0; i < 9; ++i) {
      grid = (grid << 1) + (input[i] ? 1 : 0);
    }

    let sol;
    for (sol = 0; sol < 512; ++sol) {
      if (press(grid, sol) === 511) {
        break;
      }
    }

    const newResult = [];
    for (let i = 8; i >= 0; --i, sol >>= 1) {
      newResult[i] = sol & 1;
    }

    setResult(newResult);
  };

  const handleInputChange = (index) => {
    const newInput = [...input];
    newInput[index] = !newInput[index];
    setInput(newInput);
  };

  const reset = () => {
    setInput(Array(9).fill(false));
    setResult(Array(9).fill(false));
  };

  return (
    <div className="text-white">
      <Nav />
      <div className="container mx-auto my-8 text-center">
        <h1 className="text-3xl font-bold mb-6">Light Puzzle Solver</h1>
        <div>
          Directions: Stand on one end of the puzzle and enter the pattern as
          you see the lights in the top boxes
        </div>
        <div>
          Click the "Solve Puzzle" button, and it will show you what boxes need
          to be stepped on below
        </div>
        <table className="mx-auto mb-4">
          <tbody>
            {[...Array(3).keys()].map((rowIndex) => (
              <tr key={rowIndex}>
                {[...Array(3).keys()].map((colIndex) => {
                  const index = rowIndex * 3 + colIndex;
                  return (
                    <td key={index}>
                      <div
                        className={`w-16 h-16 bg-${
                          input[index] ? "yellow" : "gray"
                        }-400 border border-gray-600 rounded-md flex items-center justify-center cursor-pointer`}
                        onClick={() => handleInputChange(index)}
                      >
                        {input[index] && (
                          <span className="text-lg">&#x25CF;</span>
                        )}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
        <button
          className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600 focus:outline-none mr-4"
          onClick={solve}
        >
          Solve Puzzle
        </button>
        <button
          className="bg-red-500 text-white py-2 px-4 rounded hover:bg-red-600 focus:outline-none"
          onClick={reset}
        >
          Reset
        </button>
        <table className="mx-auto mt-8">
          <tbody>
            {[...Array(3).keys()].map((rowIndex) => (
              <tr key={rowIndex}>
                {[...Array(3).keys()].map((colIndex) => {
                  const index = rowIndex * 3 + colIndex;
                  return (
                    <td key={index}>
                      <div
                        className={`w-16 h-16 bg-${
                          result[index] ? "green" : "red"
                        }-400 text-white border border-gray-600 rounded-md flex items-center justify-center`}
                      >
                        {result[index] && (
                          <span className="text-lg">&#x2713;</span>
                        )}
                      </div>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LightsOutSolver;
